export const SITE_OPTIONS = {
    preview: 'preview-option',
    copyUrl: 'copy-url-option',
    duplicate: 'duplicate-options',
    delete: 'delete-option',
    edit: 'edit-option',
    rename: 'rename-options',
};
